import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { CommentableTypes } from '../../redux/types';
import s from './ContentBox.scss';
/**
 * The padding and background for the main content of a comment.
 *
 * We tend to put the byline and text content in one of these.
 */
var ContentBox = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var comment = useContext(CommentContext).comment;
    var new_devpage_bg = useFlag('new_devpage_bg');
    var isFeatured = comment.isFeatured;
    return (React.createElement("div", __assign({ className: c(s['root'], isFeatured && s['featured'], className, new_devpage_bg &&
            comment.typeId === CommentableTypes.COMMENT_DEVIATION &&
            s['deviation']) }, rest), children));
};
ContentBox.displayName = 'ContentBox';
export default ContentBox;
//# sourceMappingURL=ContentBox.js.map